import { useAppSelector } from '../../App/redux/store';
import useAuth from '../auth/useAuth';
import { getUsersState } from './usersSlice';

const useUsers = () => {
  const { userIdIri } = useAuth({});
  const { users } = useAppSelector(getUsersState);

  return {
    users: users.result,
    usersStatus: users.apiStatus,
    usersWithoutAuthUser: users.result?.filter((f) => f.idIri !== userIdIri) ?? null,
    userCount: users.result?.length ?? 0,
  };
};

export default useUsers;
